/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Draft_Banner_DescInputs */

const en_directory_submit_enrich_draft_banner_desc = /** @type {(inputs: Directory_Submit_Enrich_Draft_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is submitted yet. Choose a plan — free review or fast-track — to submit your listing.`)
};

const zh_directory_submit_enrich_draft_banner_desc = /** @type {(inputs: Directory_Submit_Enrich_Draft_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未提交。选择方案——免费审核或快速通道——以提交你的收录。`)
};

/**
* | output |
* | --- |
* | "Nothing is submitted yet. Choose a plan — free review or fast-track — to submit your listing." |
*
* @param {Directory_Submit_Enrich_Draft_Banner_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_draft_banner_desc = /** @type {((inputs?: Directory_Submit_Enrich_Draft_Banner_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Draft_Banner_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_draft_banner_desc(inputs)
	return zh_directory_submit_enrich_draft_banner_desc(inputs)
});
export { directory_submit_enrich_draft_banner_desc as "directory.submit.enrich.draft_banner_desc" }